import type { AnchorHTMLAttributes, MouseEventHandler } from "react";
import { Link, type LinkProps } from "react-router-dom";
import { trackCtaClick, type CtaClickInput } from "@/lib/publicFunnel";

interface TrackingProps {
  tracking: CtaClickInput;
}

export const TrackedLink = ({ tracking, onClick, ...props }: LinkProps & TrackingProps) => {
  const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    trackCtaClick(tracking);
    onClick?.(event);
  };

  return <Link {...props} onClick={handleClick} />;
};

export const TrackedAnchor = ({
  tracking,
  onClick,
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement> & TrackingProps) => {
  const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    trackCtaClick(tracking);
    onClick?.(event);
  };

  return <a {...props} onClick={handleClick} />;
};
